import { createContext, useContext, useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";

import api from "services/api";
import { getAssetUrlFromMap, SITE_ASSET_FALLBACKS } from "utils/siteAssets";

const SiteAssetsContext = createContext({
  loading: true,
  assets: {},
  getAssetUrl: (kode) => SITE_ASSET_FALLBACKS[kode] || "",
  reloadAssets: () => {},
});

export function SiteAssetsProvider({ children }) {
  const [loading, setLoading] = useState(true);
  const [assets, setAssets] = useState({});

  const loadAssets = () => {
    setLoading(true);
    api
      .get("public/aset-gambar")
      .then((res) => {
        const map = {};
        (res.data?.data || []).forEach((item) => {
          map[item.kode] = item;
        });
        setAssets(map);
      })
      .catch(() => setAssets({}))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadAssets();
  }, []);

  const value = useMemo(
    () => ({
      loading,
      assets,
      getAssetUrl: (kode, fallback) => getAssetUrlFromMap(assets, kode, fallback),
      reloadAssets: loadAssets,
    }),
    [loading, assets]
  );

  return <SiteAssetsContext.Provider value={value}>{children}</SiteAssetsContext.Provider>;
}

SiteAssetsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useSiteAssets() {
  return useContext(SiteAssetsContext);
}

export default SiteAssetsContext;
